module.exports = __webpack_public_path__ + "images/檀程长图04-2.jpg?v=b403c10f";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan4/檀程长图04-2.jpg
 ** module id = 186
 ** module chunks = 1 2
 **/